import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { AgrPageModule } from '@next/core-lib/components';

import { DevTokensComponent } from './dev-tokens.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [DevTokensComponent],
  imports: [
    CommonModule,
    SharedModule,
    AgrPageModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    ClipboardModule,
  ],
})
export class DevTokensModule {}
